import moment from 'moment';
const app = {};

app.comma = (val) => {
    val = val * 1
    val = val.toFixed(2);
    let nStr = app.str2number(val);
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '.00';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

app.str2number = (val) => {
    val = val + '';
    return parseFloat(val.replace(/[^\d\.\-]/g, ""));
}


app.round = (val, decimals) => {
    var y = app.str2number(val);
    y = (Math.abs(y) > 0.000000001) ? y : 0;
    if (decimals === 0) {
        decimals = 0;
    } else {
        decimals = (decimals) ? decimals : 2;
    }
    var d = decimals * 1 + 8;
    d = (d > 12) ? 12 : d;
    y = Number(Math.round((y).toFixed(d) + 'e' + d) + 'e-' + d).toFixed(d);
    res = Number(Math.round((y + "").replace(/[^0-9.-]/g, '') + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    return app.str2number(res);
};

app.isMail = (mail) => {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;

    if (!mail.match(emailReg)) {
        return false
    }
    else return true;
}

app.formatDate = (date, format = 'DD-MMM-YYYY', origin = 'YYYY-MM-DD') => {
    var m = moment(date, origin);
    return (m.isValid()) ? moment(date, origin)
        .format(format) : '';
}

app.objectLength = (obj) => {
    return Object.keys(obj).length
}

app.findIndex = (array, [key, value]) => {
    return array.findIndex(x => x[key] == value);
}

app.lastUpdateAt = (updated_at) => {
    let now = new Date().getTime();
    let updated = new Date(updated_at).getTime();
    let different = now - updated;
    let days = Math.floor(different / 1000 / 60 / (60 * 24));
    let hours = Math.floor(different / 1000 / 60 / 60);
    let minutes = Math.floor(different / 1000 / 60);
    if (days > 0) {
        return days + 'd'
    }
    else if (hours > 0) {
        return hours + "h"
    }
    else if (minutes > 0) {
        return minutes + "m"
    }
    else {
        return "a few time"
    }
}

app.isoDate = (date = null) => {
    var d = (date) ? new Date(date) : new Date;
    var isoDate = new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString();
    return isoDate;
}

app.bytesToSize = (bytes) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

export default app;
